<h2 mat-dialog-title>{{ titolo }}</h2>
@if (!isHTML) {
  <p mat-dialog-content>{{ messaggio }}</p>
}
@if (isHTML) {
  <p mat-dialog-content [innerHTML]="messaggio"></p>
}
@if (stileUscita) {
  <div class="action_buttons" [class.con-padding]="conPadding">
    @if (showTerzoButton) {
      <button matButton="outlined" [mat-dialog-close]="2">{{ buttonTerText }}</button>
    }
    @if (showButtonNo) {
      <button matButton="outlined" [class.btn-danger]="!noDanger" [mat-dialog-close]="0">{{ buttonNoText }}</button>
    }
    <button matButton="filled" class="brain-btn-primary" (click)="chiudiDialog(1)">{{ buttonOkText }}</button>
  </div>
} @else {
  <mat-dialog-actions align="end">
    @if (showTerzoButton && !isSmallDevice) {
      <button mat-button color="primary" class="mr-auto" [mat-dialog-close]="2">
        {{ buttonTerText ? buttonTerText : '' }}
      </button>
    }
    @if (showButtonNo) {
      <button mat-button color="primary" mat-dialog-close (click)="chiudiDialog(0)">
        {{ buttonNoText ? buttonNoText : 'No' }}
      </button>
    }
    <button mat-flat-button class="service-primary-action" (click)="chiudiDialog(1)">{{ buttonOkText }}</button>
  </mat-dialog-actions>
}
